import React from 'react';
import QRCode from 'react-qr-code';
import { Copy } from 'lucide-react';
import { useToast } from './ToastContext';
interface QRCodeDisplayProps {
  value: string;
  avatar?: string;
}
export function QRCodeDisplay({
  value,
  avatar
}: QRCodeDisplayProps) {
  const {
    showToast
  } = useToast();
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    showToast('User ID copied to clipboard', 'success');
  };
  return <div className="flex flex-col items-center" data-id="element-159">
      <div className="relative bg-white p-4 rounded-3xl shadow-sm border border-gray-100 mb-4" data-id="element-160">
        <QRCode value={value} size={200} level="H" fgColor="#1F1F38" data-id="element-161" />
        {avatar && <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full border-4 border-white overflow-hidden shadow-sm" data-id="element-162">
            <img src={avatar} alt="User" className="w-full h-full object-cover" data-id="element-163" />
          </div>}
      </div>

      <button onClick={handleCopy} className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-purple-600 transition-colors px-4 py-2 rounded-full hover:bg-purple-50" data-id="element-164">
        <span className="font-mono" data-id="element-165">{value}</span>
        <Copy size={14} data-id="element-166" />
      </button>
    </div>;
}